import { render, staticRenderFns } from "./blame_info.vue?vue&type=template&id=cbcb990a"
import script from "./blame_info.vue?vue&type=script&lang=js"
export * from "./blame_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports